import {
  WSLoader,
  WSTableCell,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import {
  BILLING_ATTACHMENT_LOAD_FAILED_LABEL,
  BILLING_ATTACHMENT_UNAVAILABLE_LABEL,
  useBillingAttachmentFile
} from "../../../../Invoices/hooks/useBillingAttachmentFile";

type Props = {
  fileId: string;
};

export const WorkLogAttachmentNameCell: React.FC<Props> = ({ fileId }) => {
  const file = useBillingAttachmentFile(fileId);

  if (file.isLoading) {
    return <WSLoader.Spinner size="XS" />;
  }

  if (file.isUnavailable || file.isLoadFailed) {
    return (
      <WSText.ParagraphSm color="gray400">
        {file.isUnavailable
          ? BILLING_ATTACHMENT_UNAVAILABLE_LABEL
          : BILLING_ATTACHMENT_LOAD_FAILED_LABEL}
      </WSText.ParagraphSm>
    );
  }

  return <WSTableCell text={file.filename || "Unknown file"} />;
};
